module.exports = __webpack_public_path__ + "/img/b58a3170e4e4a9296798dea0e91acd58.png";


/*****************
 ** WEBPACK FOOTER
 ** ./src/client/assets/appimg/mk_img_01.png
 ** module id = 29
 ** module chunks = 0 4 5
 **/